import { IApiEmployee, IUserInput, getDepartmentIdFromIdent, getUniqueItemsByKey } from 'next-common';

export const mapEmployeeToUser = (employee: IApiEmployee, selectedDealer: string): Partial<IUserInput> => {
  const identity = employee?.employeeId;
  return {
    departmentId: selectedDealer || getDepartmentIdFromIdent(identity),
    email: employee?.email,
    employeeId: employee?.id,
    firstName: employee?.firstName,
    lastName: employee?.lastName,
    ident: identity,
    mobilePhone: employee?.phone,
  };
};

export const getEmployeeDealerIds = (employee: IApiEmployee, isAdmin: boolean): string[] => {
  const employeeDealerIds: string[] = employee?.employeeRoles
    ? getUniqueItemsByKey(employee?.employeeRoles, 'dealerId')?.map((role) => role?.dealerId)
    : [];

  if (employee?.departmentNumber && !employeeDealerIds?.includes(employee?.departmentNumber)) {
    employeeDealerIds?.push(employee?.departmentNumber);
  }

  return isAdmin ? employeeDealerIds : [employee?.departmentNumber];
};

export const getEmployeeDealers = (
  employee: IApiEmployee,
  isAdmin: boolean
): { dealerId: string; dealerName?: string }[] => {
  const uniqueDealers = employee?.employeeRoles ? getUniqueItemsByKey(employee.employeeRoles, 'dealerId') : [];

  const employeeDealerList = uniqueDealers.map((role) => ({
    dealerId: role?.dealerId,
    dealerName: role?.dealerName,
  }));

  if (employee?.departmentNumber && !employeeDealerList.some((d) => d.dealerId === employee.departmentNumber)) {
    employeeDealerList.push({
      dealerId: employee.departmentNumber,
      dealerName: employee.departmentName,
    });
  }

  return isAdmin
    ? employeeDealerList
    : [{ dealerId: employee?.departmentNumber, dealerName: employee?.departmentName }];
};

export const isOwnLocation = (dealerIds: string[], locationId: string): boolean => {
  return dealerIds?.includes(locationId?.toString());
};

export const isImporterLocation = (importerLocationIds: string[], locationId: string): boolean => {
  return importerLocationIds?.includes(locationId?.toString());
};
